import {ChartOptions} from 'chart.js';
import moment from 'jalali-moment';
import {Line} from 'react-chartjs-2';
import useGetStoreViews from '../../../../../services/hookService/getStoreViews/useGetStoreViews';

const ChartTabBar = () => {
  const {data} = useGetStoreViews();

  /**
   * Convert all dates to jalali moments
   */

  if (!data || data.length === 0) return null;

  const allDates =
    data
      ?.map(item => moment(item.date).locale('fa'))
      .sort((a, b) => a.valueOf() - b.valueOf()) || [];

  const firstDate = allDates[0];
  const lastDate = allDates[allDates.length - 1];

  /**
   * Difference between first and last date
   */
  const totalDays = lastDate?.diff(firstDate, 'days') + 1;

  /**
   * Generate ALL dates between range
   * including missing dates
   */
  const generatedDays = Array.from({length: totalDays}, (_, index) => {
    const current = firstDate.clone().add(index, 'days');

    return {
      key: current.format('jYYYY-jMM-jDD'),
      day: current.format('jD'),
      month: current.format('jMMMM'),
    };
  });

  /**
   * Fast lookup map
   */
  const dataMap = new Map(
    data?.map(item => {
      const m = moment(item.date).locale('fa');

      return [m.format('jYYYY-jMM-jDD'), item.view_quantity];
    }) || [],
  );

  /**
   * Build chart data
   */
  const dataClac = {
    labels: generatedDays.map(item => item.key),

    datasets: [
      {
        data: generatedDays.map(item => dataMap.get(item.key) || 0),

        borderColor: '#4f7a20',

        fill: false,

        borderWidth: 1.5,
        tension: 0.4,
        pointRadius: 2,
      },
    ],
  };

  const options: ChartOptions<'line'> = {
    interaction: {
      mode: 'nearest',
      intersect: false,
      axis: 'x',
    },

    layout: {
      padding: {
        top: 20,
      },
    },

    scales: {
      x: {
        title: {
          display: true,
          text: 'تاریخ',
        },

        ticks: {
          autoSkip: true,
          maxTicksLimit: 15,

          maxRotation: 0,
          minRotation: 0,

          font: {
            size: 10,
            weight: 'bold',
          },

          callback: function (value, index) {
            const current = generatedDays[index];

            if (!current) return '';

            return [current.day, current.month];
          },
        },

        grid: {
          display: false,
        },
      },

      y: {
        title: {
          display: false,
          text: 'تعداد بازدید',
        },

        ticks: {
          stepSize: 5,
        },

        min: 0,
      },
    },

    plugins: {
      legend: {
        display: false,
      },

      tooltip: {
        rtl: false,
        textDirection: 'rtl',

        displayColors: false,

        backgroundColor: '#4f7a20',

        titleAlign: 'right',

        bodyAlign: 'right',

        titleFont: {
          family: 'IRANYekanXVF',
          size: 12,
        },

        bodyFont: {
          family: 'IRANYekanXVF',
          size: 12,
        },

        callbacks: {
          title: tooltipItems => {
            if (!tooltipItems.length) return '';

            const index = tooltipItems[0].dataIndex;

            const current = generatedDays[index];

            return `${current.day} ${current.month}`;
          },

          label: tooltipItem => {
            return `${tooltipItem.raw} بازدید`;
          },
        },
      },

      datalabels: {
        display: false,
      },
    },

    maintainAspectRatio: false,
  };

  return (
    <div className="flex flex-col w-full mt-4">
      <div className="flex flex-col w-full rounded-lg bg-gray-50">
        <p className="px-3 pt-3 text-sm text-gray-950 font-Regular">
          تعداد کل بازدید:{' '}
          {data?.reduce(
            (accumulator, currentValue) =>
              accumulator + currentValue.view_quantity,
            0,
          )}
        </p>

        <span className="inline-block pl-1 text-xs text-left text-gray-900">
          تعداد بازدید
        </span>

        <div className="w-full h-64">
          <Line
            className="w-full h-full"
            options={options}
            data={dataClac}
            height={500}
            width={'100%'}
          />
        </div>
      </div>
    </div>
  );
};

export default ChartTabBar;
